const ITEMS = [
  'VOGUE SCANDINAVIA', '✦', 'ARCHITECTURAL DIGEST', '✦', 'BOTTEGA VENETA',
  '✦', 'LE MONDE', '✦', 'BIELEFELD KUNSTHALLE', '✦', 'PIN-UP MAGAZINE',
  '✦', 'HERMÈS', '✦', 'DESIGN ANTHOLOGY', '✦', 'APERTURE FOUNDATION', '✦',
  'PARIS PHOTO', '✦', 'LEICA GALLERY', '✦',
];

export default function EditorialMarquee() {
  const doubled = [...ITEMS, ...ITEMS];

  return (
    <div className="marquee-wrapper py-6 border-t border-b border-black/[0.05] overflow-hidden bg-[#F5F3EC]">
      <div className="marquee-inner flex gap-10 whitespace-nowrap">
        {doubled.map((item, i) => (
          <span
            key={i}
            className={`flex-shrink-0 ${
              item === '✦'
                ? 'text-[#B88349] text-[10px]'
                : 'font-serif italic text-[13px] text-neutral-400 tracking-[0.1em]'
            }`}
          >
            {item}
          </span>
        ))}
      </div>
    </div>
  );
}
